import { DocsStoreDispatch } from '@squareup/dex-shell-docs-core';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { useDispatch } from 'react-redux';

type DispatchFunc = () => DocsStoreDispatch;
export const useDocsDispatch: DispatchFunc = useDispatch;
